// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-LongDate_cls1__7GMeQ","cls2":"VeloTable-LongDate_cls2__lQFin VeloTable-LongDate_cls1__7GMeQ"};